import { Charts } from './Charts';
import HouseholdChartsDataProvider from './contexts/HouseholdChartsDataContext';

const HouseholdWrapper = () => {
    return (
        <HouseholdChartsDataProvider>
            <Charts />
        </HouseholdChartsDataProvider>
    );
};

export default HouseholdWrapper;
